import { render, staticRenderFns } from "./FooterApps.vue?vue&type=template&id=c9bdea52&"
import script from "./FooterApps.vue?vue&type=script&lang=js&"
export * from "./FooterApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports